import { render, staticRenderFns } from "./ManageSupplierDocuments.vue?vue&type=template&id=69e97164&scoped=true"
import script from "./ManageSupplierDocuments.vue?vue&type=script&lang=js"
export * from "./ManageSupplierDocuments.vue?vue&type=script&lang=js"
import style0 from "./ManageSupplierDocuments.vue?vue&type=style&index=0&id=69e97164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e97164",
  null
  
)

export default component.exports